export default __webpack_public_path__ + "assets/ca106b31308015b62756a390264e1612.png";